import { render } from "./pckDownload.vue?vue&type=template&id=222f43c3&scoped=true"
import script from "./pckDownload.vue?vue&type=script&lang=js"
export * from "./pckDownload.vue?vue&type=script&lang=js"

import "./pckDownload.vue?vue&type=style&index=0&id=222f43c3&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f43c3"]])

export default __exports__